import {
  AssistantMessage,
  AssistantUserMessage,
} from '@/components/assistant/messages/AssistantMessage'
import { AssistantFeedItem } from '@/store/assistant'
import { useT } from '@repo/ui/hooks'

export function MessageHandler({ item }: { item: AssistantFeedItem }) {
  if (item.type !== 'message') return null

  const { t } = useT({ keyPrefix: 'assistant' })

  const content = 'content' in item ? item.content : t(item.transKeyContent)
  if (item.isFromUser)
    return <AssistantUserMessage key={item.id}>{content}</AssistantUserMessage>
  return (
    <AssistantMessage traceUrl={item.traceUrl} key={item.id}>
      {content}
    </AssistantMessage>
  )
}
